import React from 'react';
import debounce from 'lodash.debounce';
import SideContentLayout from '@/layouts/Main/sideContentLayout';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
import { apiHolder as api } from 'api';
const STORE_MAIL_LIST_HEIGHT = 'STORE_MAIL_LIST_HEIGHT';
import { mailListWidthStorePut, DEFAULT_LIST_MIN_WIDTH } from '@web-mail/hooks/useAppScale';
const storeApi = api.api.getDataStoreApi();
const defaultObject = {};
const MailColumnEntryContainer = ({ children, height, showMailColumn, isLeftRight, isUpDown, defaultListWidth, openInNewWindow, upDownProps = defaultObject, maxWidth, setMailListResizeProcessing, }) => {
    if (openInNewWindow) {
        return React.createElement(React.Fragment, null);
    }
    const resizeList = React.useCallback(debounce((_, data) => {
        const { size: { width }, } = data;
        if (isLeftRight) {
            mailListWidthStorePut(width);
        }
        else if (isUpDown) {
            storeApi.putSync(STORE_MAIL_LIST_HEIGHT, height, { prefix: 'layout_storage_cache', storeMethod: 'localStorage' });
        }
    }, 150), [isLeftRight, isUpDown]);
    if ((isLeftRight || isUpDown) && showMailColumn) {
        return (React.createElement(SideContentLayout, Object.assign({ borderRight: true, minWidth: DEFAULT_LIST_MIN_WIDTH, maxWidth: maxWidth, defaultWidth: defaultListWidth, className: "m-email-list", resizeClassName: isUpDown ? 'upDownResize' : '', style: { position: 'relative' }, innerStyle: isUpDown ? { width: '100%' } : undefined, forbidGridWeb: !!isUpDown, onResize: resizeList, onResizeStop: () => {
                setMailListResizeProcessing && setMailListResizeProcessing(false);
            }, onResizeStart: () => {
                setMailListResizeProcessing && setMailListResizeProcessing(!0);
            } }, upDownProps),
            React.createElement(ErrorBoundary, { name: "MailColumnEntryContainer" }, children)));
    }
    const outerStyle = {
        height,
        flex: 1,
        position: 'relative',
        overflow: 'hidden',
    };
    const innerStyle = {
        position: 'absolute',
        inset: '0px',
        overflowX: 'overlay',
        overflowY: 'hidden',
        width: '100%',
        height: '100%',
    };
    return (React.createElement("div", { style: outerStyle, SideContentLayout: true, hidden: !showMailColumn },
        React.createElement("div", { style: innerStyle },
            React.createElement("div", { style: { minWidth: isLeftRight ? '764px' : '650px', flex: 1, position: 'relative', height: '100%' } },
                React.createElement(ErrorBoundary, { name: "MailColumnEntryContainer-1" }, children)))));
};
export default MailColumnEntryContainer;
